'use client';

import { useEffect } from 'react';

interface VapiChatWidgetProps {
  enabled?: boolean;
}

export default function VapiChatWidget({ enabled = true }: VapiChatWidgetProps) {
  useEffect(() => {
    if (!enabled) return;

    // Load the VAPI widget script
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/@vapi-ai/client-sdk-react/dist/embed/widget.umd.js';
    script.async = true;
    script.type = 'text/javascript';
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, [enabled]);

  if (!enabled) return null;

  return (
    <vapi-widget
      public-key="f321763b-08b1-4679-932a-06bd8a6dbcb8"
      assistant-id="328f6eca-6908-49b7-b5f7-7bd2be1c295e"
      mode="chat"
      theme="light"
      size="compact"
      radius="large"
      base-color="#FFFFFF"
      accent-color="#3B82F6"
      button-base-color="#1a1a1a"
      button-accent-color="#FFFFFF"
      main-label="Chat with Support"
      start-button-text="Start Voice Chat"
      end-button-text="End Call"
      empty-chat-message="Hi! How can I help you today?"
      empty-voice-message="Click to start a voice conversation"
    />
  );
}

// TypeScript declaration for custom element
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'vapi-widget': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement> & {
        'public-key'?: string;
        'assistant-id'?: string;
        mode?: string;
        theme?: string;
        size?: string;
        radius?: string;
        'base-color'?: string;
        'accent-color'?: string;
        'button-base-color'?: string;
        'button-accent-color'?: string;
        'main-label'?: string;
        'start-button-text'?: string;
        'end-button-text'?: string;
        'empty-chat-message'?: string;
        'empty-voice-message'?: string;
      }, HTMLElement>;
    }
  }
}